import { convertTimezone } from "@/common/tenancy/convertTimezone";

// state
const state = () => ({
  fields: [],
  filterParams: {},
  searchModel: "",
  integrationModel: [],
  crmStatusModel: [],
  blacklistStatusModel: "",
  countIntegration: 0,
  isSaleContactAdvance: true,
  saleContactAdvance: null,
  provinceModel: "",
  pointModel: "",
  tagsModel: [],
  lastOrderDateModel: "",
  createDateModel: {
    startDate: null,
    endDate: null
  },
  perPageModel: 10,
  createDate: "",
  customerId: 0,
  modalAt: "",
  totalItems: 0,
  isLoaded: 0,
  tabActive: "all",
  canCustomerView: true,
  canComingSoon: false,
  updateBookmarkColumn: null,
  isOpenCustomerModalForm: false,
  isProgressBarActivity: false,
  activityDataPregressBar:{},
  updateCustomerDataTablePregressBar: 0,
  customerDataListPregressBar: [],
  isCustomerLoadingPregressBar: false,
  isModalSendCustomer: false,
  setCustomerData: {},
  returnOrderModel: "",
});

// getters
const getters = {
  fieldOnlyToggleable: function (state) {
    return state.fields.filter(field => field.toggleable === true);
  },
  isFilterTagAdded: function (state) {
    const integrationTags = state.integrationModel.length > 0;
    const provinceTags = state.provinceModel !== "" ? 1 : 0;
    return (integrationTags || provinceTags);
  },
  filterSummary: function (state) {
    let integrations = state.integrationModel.length;
    if(!state.isSaleContactAdvance){
      integrations = state.countIntegration;
    }
    const provinces = state.provinceModel !== "" ? 1 : 0;
    const points = state.pointModel !== "" && state.pointModel !== "," ? 1 : 0;
    const tags = state.tagsModel !== "" ? state.tagsModel.length : 0;
    const crms = state.crmStatusModel !== "" ? 1 : 0;
    const blacklist = state.blacklistStatusModel !== "" ? 1 : 0;
    const returnorder = state.returnOrderModel !== "" ? 1 : 0;
    return integrations + provinces + points + tags + crms + blacklist + returnorder;
  },
  bookmarkColumn: function(state) {
    return state.updateBookmarkColumn;
  }
};

// actions
const actions = {
  initFields({ commit }, fields) {
    commit('initFields', fields);
  },
  toggleColumn({ commit }, fieldName) {
    commit('setField', fieldName);
  },
  addQueryParam({ commit }, params) {
    commit('setQueryParam', params);
  },
  removeIntegrationModelItem({ commit, state }, id) {
    const newIntegration = state
      .integrationModel
      .filter(integration => integration.id !== id);
    commit('updateIntegrationModel', newIntegration);
  },
  removeProvinceModelItem({ commit, state }, removeName) {
    const newProvince = state
      .provinceModel
      .filter(proviceName => proviceName !== removeName);
    commit('updateProvinceModel', newProvince);
  },
  submitQueryParams({ commit, state }) {
    const search = state.searchModel;

    let createDate = "";
    if (state.createDateModel.startDate !== null) {
      let startDate = state.createDateModel.startDate.toISOString();
      startDate = convertTimezone.localToUtc(startDate.substring(0, 10)+" 00:00:00");
      let endDate = state.createDateModel.endDate.toISOString();
      endDate = convertTimezone.localToUtc(endDate.substring(0, 10)+" 23:59:59");
      createDate = `${startDate},${endDate}`;
    }

    let integrationId = "";
    if (state.integrationModel.length > 0) {
      // integrationId = state.integrationModel.map(integration => integration.id).join(",");
      integrationId = state.integrationModel.join(",");
    }

    let crm = "";
    if (state.crmStatusModel !== "") {
      crm = state.crmStatusModel;
    }

    let blacklist = "";
    if (state.blacklistStatusModel !== ""){
      blacklist = state.blacklistStatusModel;
    }

    let province = "";
    if (state.provinceModel !== "") {
      province = state.provinceModel;
    }

    let saleContactAdvanceSetting = "";
    if (state.saleContactAdvance !== "") {
      saleContactAdvanceSetting = state.saleContactAdvance;
    }

    let point = "";
    if (state.pointModel !== "") {
      point = state.pointModel;
    }

    let tags = "";
    if (state.tagsModel.length > 0) {
      tags = state.tagsModel;
    }

    let lastOrderDate = "";
    if (state.lastOrderDateModel.length > 0) {
      lastOrderDate = state.lastOrderDateModel.join(",");
    }

    let perPage = 10;
    if (state.perPageModel !== "") {
      perPage = state.perPageModel;
    }

    let returnorder = "";
    if (state.returnOrderModel !== ""){
      returnorder = state.returnOrderModel;
    }

    const params = {
      search: search,
      created_date: createDate,
      integration_id: integrationId,
      saleContactAdvance: saleContactAdvanceSetting,
      state: province,
      crm_status: crm,
      point: point,
      tags: tags,
      last_order_date: lastOrderDate,
      per_page: perPage
    };

    commit('setQueryParam', params);
  },
  clearAllFilter({ commit }) {
    // commit("updateSearchModel", "");
    // commit("updateCreateDateModel", { startDate: null, endDate: null });
    commit("updateIntegrationModel", []);
    commit("updateCountIntegration", 0);
    commit("updateProvinceModel", "");
    commit("updateCRMStatusModel", "");
    commit("updateBlacklistStatusModel", "");
    commit("updatePointModel", "");
    commit("updateTagsModel", []);
    commit("updateLastOrderDateModel", "");
    commit("updatePerPageModel", 10);
    commit("updateReturnOrderModel", "");
  },
  isProgressBarActivity({ commit }, fields) {
    commit('isProgressBarActivity', fields);
  },
  isModalSendCustomer({ commit }, payload) {
    commit('setModalSendCustomer', payload);
  },
  activityDataPregressBar({ commit }, fields) {
    commit('activityDataPregressBar', fields);
  },
  setInProgressBarCustomer({ commit }, payload) {
    commit('setInProgressBarCustomer', payload);
  },
  setCustomerData({ commit }, fields){
    commit('setCustomerData', fields);
  },
  updateCustomerDataTablePregressBar({ commit }, data) {
    commit('updateCustomerDataTablePregressBar', data);
  },
  customerDataListPregressBar({ commit }, data) {
    commit('setCustomerDataListPregressBar', data);
  },

};

// mutations
const mutations = {
  initFields(state, initFields) {
    state.fields = initFields;
  },
  setField(state, fieldName) {
    const newFields = state.fields.map(field => {
      if (field.name === fieldName) {
        return Object.assign(field, { visible: !field.visible });
      }
      return field;
    });
    state.fields = newFields;
  },
  setQueryParam(state, newParam) {
    Object.assign(state.filterParams, newParam);
  },
  removeQueryParam(state, newParam) {
    delete state.filterParams[newParam];
  },
  updateSearchModel(state, newSearchModel) {
    state.searchModel = newSearchModel;
  },
  updateIntegrationModel(state, newIntegrationModel) {
    state.integrationModel = newIntegrationModel;
  },
  updateCountIntegration(state, newCountIntegration) {
    state.countIntegration = newCountIntegration;
  },
  updateIsSaleContactAdvance(state, newIsSaleContactAdvance){
    state.isSaleContactAdvance = newIsSaleContactAdvance;
  },
  checkSaleContactAdvance(state, newSaleContactAdvance) {
    state.saleContactAdvance = newSaleContactAdvance;
  },
  updateProvinceModel(state, newProvinceModel) {
    state.provinceModel = newProvinceModel;
  },
  updatePointModel(state, newPointModel) {
    state.pointModel = newPointModel;
  },
  updateTagsModel(state, newTagsModel) {
    state.tagsModel = newTagsModel;
  },
  updateLastOrderDateModel(state, newLastOrderDateModel) {
    state.lastOrderDateModel = newLastOrderDateModel;
  },
  updateCreateDateModel(state, newCreateDateModel) {
    state.createDateModel = newCreateDateModel;
  },
  updatePerPageModel(state, newPerPageModel) {
    state.perPageModel = newPerPageModel;
  },
  updateCustomerId(state, newCustomerId) {
    state.customerId = newCustomerId;
  },
  updateModalAt(state, newModalAt) {
    state.modalAt = newModalAt;
  },
  updateTotalItems(state, newTotalItems) {
    state.totalItems = newTotalItems;
  },
  updateIsLoaded(state, newIsLoaded) {
    state.isLoaded = newIsLoaded;
  },
  updateTabActive(state, newTabActive) {
    state.tabActive = newTabActive;
  },
  updateCanCustomerView(state, newCanCustomerViewState) {
    state.canCustomerView = newCanCustomerViewState;
  },
  updateComingSoon(state, newCanComingSoonState) {
    state.canComingSoon = newCanComingSoonState;
  },
  updateBookmarkColumn(state, newBookmarkColumnState) {
    state.updateBookmarkColumn = newBookmarkColumnState;
  },
  updateCustomerModalForm(state, newCustomerModalFormState) {
    state.isOpenCustomerModalForm = newCustomerModalFormState;
  },
  updateCRMStatusModel(state, newCRMStatusModel) {
    state.crmStatusModel = newCRMStatusModel;
  },
  updateBlacklistStatusModel(state, newBlacklistStatusModel) {
    state.blacklistStatusModel = newBlacklistStatusModel;
  },
  updateReturnOrderModel(state, newReturnOrderModel) {
    state.returnOrderModel = newReturnOrderModel;
  },
  isProgressBarActivity(state, data) {
    state.isProgressBarActivity = data;
  },
  activityDataPregressBar(state, data) {
    state.activityDataPregressBar = data;
  },
  setModalSendCustomer(state, data) {
    state.isModalSendCustomer = data;
  },
  setCustomerData(state, data) {
    state.setCustomerData = data;
  },
  setInProgressBarCustomer(state, payload) {
    state.customerDataListPregressBar['data'] = state.customerDataListPregressBar['data'].map(function(Customerlist){
      if(!payload.status){
        payload.status = true;
      }

      if(payload.CustomerIds.includes(Customerlist.id)){
        return {...Customerlist, loading: payload.status};
      }

      return Customerlist;
    });

    state.isCustomerLoadingPregressBar = !state.isCustomerLoadingPregressBar;
  },
  updateCustomerDataTablePregressBar(state, data) {
    state.customerDataListPregressBar['data'] = state.customerDataListPregressBar['data'].map(function(customerlist){
      customerlist['loading'] = false;
      return customerlist;
    });
    state.isCustomerLoadingPregressBar = !state.isCustomerLoadingPregressBar;
    state.updateCustomerDataTablePregressBar++;
  },
  setCustomerDataListPregressBar(state, data) {
    state.customerDataListPregressBar = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/customer.js